let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l8YJv")).then(() => parcelRequire('fbjoe'));